export const COLORS = { highlight: { one: "#4CD7F4" } };
export const TEXT_COLORS = { one: "#ffffff", two: "#A5A5A8", three: "#6A6A6D" };
export const LAYER_COLORS = { one: "#12121A", two: "#18181E" };
export const BORDER_COLORS = { two: "#1A1A1F" };
